interface ExperimentalMessage {
	messageTemplateId: string;
	statsigExperiment: string;
	statsigParameterName: string;
	statsigTestCohortPredicate: (experimentValue: string) => boolean;
	/**
	 * Optional environment / client predicate that determines if this message
	 * should proceed to Statsig evaluation (and have exposure recorded)
	 * in the current context.
	 *
	 * If omitted, the message always proceeds to Statsig evaluation.
	 */
	shouldProceedToStatsigEvaluation?: () => boolean;
}

export const NOT_ENROLLED_COHORT = 'not-enrolled';

const NON_VARIANT_COHORTS = new Set(['control', NOT_ENROLLED_COHORT]);

// Entries are iterated through using the ML ranking order - the order in the list is not important
export const EXPERIMENTAL_MESSAGES: ExperimentalMessage[] = [
	{
		// https://switcheroo.atlassian.com/ui/gates/4bb14a49-572d-4f41-99b8-3d8ca5260adc/key/rovo-ext_left_nav_rovo_extension_cta
		messageTemplateId: 'rovo-extension-install-cta-left-nav',
		statsigExperiment: 'rovo-ext_left_nav_rovo_extension_cta',
		statsigParameterName: 'cohort',
		statsigTestCohortPredicate: (experimentValue: string) =>
			!NON_VARIANT_COHORTS.has(experimentValue),
		shouldProceedToStatsigEvaluation: () => {
			if (typeof navigator === 'undefined') {
				return false;
			}
			const userAgent = navigator.userAgent || '';
			return userAgent.indexOf('Chrome') >= 0;
		},
	},
];
